export default "__VITE_ASSET__uDpKpnpnWqNgLJVbbzoX1Q__";